module.exports = __webpack_public_path__ + "img/649.deafd539.gif";